import CardTemplate from "@appsinti/ui-core/CardTemplate";
import React from "react";
import { CustomRow } from "../styles";
import CardTitleComponent from "../CardTitleComponent";
import { MetricData } from "@appsinti/ui-core/styles";
import StatsPreview from "../../../interfaces/StatsPreview";
import styled from "styled-components";

const MainColumn = styled.div`
  &.main {
    display: flex;
    flex-direction: column;
    gap: 15px;

    @media screen and (max-width: 380px) {
      gap: 10px;
    }
  }
`;

const Reservations: React.FC<{ preview: StatsPreview }> = ({ preview }) => {
  return (
    <CardTemplate
      background={"white"}
      body={
        <CustomRow>
          <MainColumn className="main">
            <div className="column">
              <MetricData size={"medium"} weight={"bold"}>PEOPLE</MetricData>
              <MetricData size={"biggest"} weight={"bold"}>
                {`${preview.total.customerSeatedCount}/${preview.total.customerDoneCount + preview.total.customerSeatedCount}`}
              </MetricData>
            </div>
            <div className="column">
              <MetricData size={"medium"} weight={"bold"}>RESERVE</MetricData>
              <MetricData size={"biggest"} weight={"bold"}>
                {`${preview.total.reservationCount}r / ${preview.total.reservationPeopleCount}p`}
              </MetricData>
            </div>
          </MainColumn>
        </CustomRow>
      }
    />
  );
};

export default Reservations;
